const messages = {
  title: "Kits média & logos",
  title_media: "Kits média & logos",
  description:
    "Notre médiathèque propose une large sélection de contenus des marques Bridgestone et Firestone," +
    " ainsi que d’autres solutions du groupe.<br/>" +
    "Utilisez les différents filtres ou effectuez une recherche ciblée dans la barre prévue à cet" +
    " effet pour trouver rapidement le contenu souhaité.",
  short_description:
    "Vous trouverez ici des données sur les réseaux sociaux, la télévision en magasin et bien plus encore.",
  mediaCategories: {
    products: "Produits",
    brand_and_solutions: "Marques & Solutions",
    season_and_promotions: "Saison & Promotions",
    format: "Format",
    cars_and_vans: "Voiture, SUV, Utilitaire",
    truck_and_buses: "Poids lourds & Bus",
    motorcycle: "Moto",
    agriculture: "Agriculture",
    construction_machinery: "Engins de construction",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Matériaux",
    brochures: "Brochures produit",
    price_list: "Listes de prix",
    materials: "Matériaux",
    video_in_store: "Vidéo avec sous-titres",
    video_online: "Vidéo sans sous-titres",
    video: "Vidéo",
    banner_website: "Bannière",
    banner_social_media: "Réseaux sociaux",
    logos: "Logos",
    summer: "Été",
    winter: "Hiver",
    all_season: "Toutes saisons",
    promotions: "Promotions",
    price: "Pricat",
  },
  mediasPage: {
    title: "MÉDIATHÈQUE",
    description:
      "Bienvenue dans la section média dédiée   \n" +
      "aux produits Bridgestone et Firestone.  \n <br> <br>" +
      "Vous y découvrirez des visuels produits, des   \n" +
      "logos, ainsi qu’une large sélection de   \n" +
      "bannières, de vidéos et de supports digitaux   \n" +
      "à utiliser sur votre site web ou sur les   \n" +
      "réseaux sociaux.  ",
    bDrive: {
      title: "Photos produits",
      description:
        "Les images actuelles   \n" +
        "peuvent être téléchargées   \n" +
        "depuis notre portail B-\n" +
        "DRIVE.  ",
    },
  },
  buttons: {
    media: "DÉCOUVRIR",
  },
  searchMedia: "Saisir un mot-clé",
  searchResults: "Résultats de recherche",
};

export default {
  messages,
};
